module.exports = __webpack_public_path__ + "static/media/vi.1cf3c45b.png";